import { BankTransactionModel } from 'api-hooks/transactions/bank-transaction';
import React from 'react';

import { BankTransactionFormType } from '../components/form-type';

interface Props {
  bankTransaction?: BankTransactionModel;
}

export default function useGetDefaultValues(props: Props) {
  const { bankTransaction } = props;
  const defaultValues = React.useMemo<BankTransactionFormType>(() => {
    return {
      transactionCategoryId: bankTransaction?.transactionCategory?.id || null,
      transactionAt: bankTransaction?.transactionAt || new Date(),
      tempTransactionAt: bankTransaction?.transactionAt || new Date(),
      needApproval: false,
      bankAccountId: bankTransaction?.bankAccount.id || '',
      type: bankTransaction?.type || '',
      amount: bankTransaction?.amount || 0,
      description: bankTransaction?.description || '',
      number: bankTransaction?.number || '',
      refId: bankTransaction?.refId,
    };
  }, [bankTransaction]);

  return defaultValues;
}
